import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-2"
};
const _hoisted_3 = {
  key: 1,
  class: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-2"
};
const _hoisted_4 = ["aria-pressed", "title", "onClick"];
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = ["title"];
import { Check, Setting } from '@element-plus/icons-vue';
export default {
  __name: 'OfficialPublisherPicker',
  props: {
    publishers: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select', 'manage'],
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-900"
      }, "发布者信息", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        title: "管理官方发布者",
        "aria-label": "管理官方发布者",
        class: "w-8 h-8 flex items-center justify-center rounded-md text-slate-400 hover:text-primary-500 hover:bg-primary-50 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('manage'))
      }, [_createVNode(_component_el_icon, {
        size: 16
      }, {
        default: _withCtx(() => [_createVNode(_unref(Setting))]),
        _: 1
      })])), [[_directive_permission, 'app:circle:publisher:manage']])]), __props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
        return _createElementVNode("div", {
          key: index,
          class: "min-h-[72px] rounded-lg border border-slate-200 bg-slate-50 animate-pulse"
        });
      }), 64))])) : __props.publishers.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.publishers, publisher => {
        return _openBlock(), _createElementBlock("button", {
          key: publisher.id,
          type: "button",
          "aria-pressed": publisher.id === __props.selectedId,
          title: publisher.nickname,
          class: _normalizeClass(["relative flex min-h-[72px] flex-col items-center justify-center gap-1.5 rounded-lg border px-2 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300", publisher.id === __props.selectedId ? 'border-primary-500 bg-primary-50' : 'border-slate-200 bg-white hover:border-primary-300 hover:bg-slate-50']),
          onClick: $event => _ctx.$emit('select', publisher)
        }, [_createElementVNode("img", {
          src: publisher.avatarUrl,
          alt: publisher.nickname,
          class: "h-8 w-8 rounded-full object-cover"
        }, null, 8, _hoisted_5), _createElementVNode("span", {
          class: "w-full truncate text-center text-xs text-slate-700",
          title: publisher.nickname
        }, _toDisplayString(publisher.nickname), 9, _hoisted_6), publisher.id === __props.selectedId ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "absolute right-1 top-1 text-primary-500"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Check))]),
          _: 1
        })) : _createCommentVNode("", true)], 10, _hoisted_4);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};